import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-section-carousel-dots',
	templateUrl: './section-carousel-dots.component.html',
	styleUrls: ['./section-carousel-dots.component.css']
})
export class SectionCarouselDotsComponent implements OnInit {
	numbers: Array<number>;

	@Input() activeDot = 0;
	@Input() dotsCount: number;

	@HostBinding('class')
	@Input()
	position = 'left';

	@Output() onClick: EventEmitter<number> = new EventEmitter<number>();

	constructor() {}

	ngOnInit() {
		this.numbers = Array(this.dotsCount)
			.fill(0)
			.map((x, i) => i);
	}

	click(index: any) {
		this.onClick.emit(index);
		this.activeDot = index;
	}
}
